export default "__VITE_ASSET__CVE0o_PD__$_?no-inline__"